import { AuthService } from './../../../services/auth.service';
import { Client } from './../../../models/client';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-client-view',
  templateUrl: './client-view.component.html',
  styleUrls: ['./client-view.component.css']
})
export class ClientViewComponent implements OnInit {

  client: Client;
  isAccountPage: boolean;
  pack: Array<Select2OptionData>;

  // ─── Confirmation Dialog ────────────────────────────────────────
  showConfirmModal = false;
  confirmTitle = '';
  confirmMessage = '';
  confirmIcon = '';
  confirmBtnText = '';
  confirmBtnClass = '';
  confirmAction: () => void = null;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {
    this.client = new Client();
    this.pack = [
      { id: '', text: 'Choisir un type' },
      { id : '1', text: 'Start' },
      { id : '2', text: 'Essentiel' },
      { id : '3', text: 'Pro' },
    ];
    this.isAccountPage = (this.router.url.indexOf('/account') === 0);
    this.route.params.subscribe(params => {
      const id = this.isAccountPage ? authService.getUser().id : params['id'];
      this.http.get(
        '/api/client/' + id
      ).subscribe((client: any) => {
        this.client = client;
        this.pack = this.pack.map((data, index) => {
          return {
            id: data.id,
            text: data.text,
            selected: (data.id == client.pack) ? true : false
           };
        });
      });
    });
  }

  ngOnInit() {
  }

  dateTimeFilter = (d: Date): boolean => {
    return true;
  }

  openDeleteConfirm() {
    this.confirmTitle = 'Supprimer le client DEMO';
    this.confirmMessage = `ATTENTION: Supprimer définitivement le client DEMO "${this.client.name}" ?\n\nCette action est IRRÉVERSIBLE. Toutes les données (écoles, bus, passagers, trajets, zones) seront supprimées.`;
    this.confirmIcon = 'fa fa-trash';
    this.confirmBtnText = 'Supprimer';
    this.confirmBtnClass = 'btn btn-danger';
    this.confirmAction = () => { this.executeDelete(); };
    this.showConfirmModal = true;
  }

  executeConfirm() {
    this.showConfirmModal = false;
    if (this.confirmAction) { this.confirmAction(); }
  }

  executeDelete() {
    this.http.delete(`/api/admin/clients/${this.client.id}`).subscribe(
      (result: any) => {
        this.confirmTitle = 'Succès';
        this.confirmMessage = `Client DEMO supprimé avec succès.\n\nÉcoles: ${result.summary.schools}\nBus: ${result.summary.buses}\nTrajets: ${result.summary.journeys}\nPassagers: ${result.summary.passengers}`;
        this.confirmIcon = 'fa fa-check';
        this.confirmBtnText = 'Ok';
        this.confirmBtnClass = 'btn btn-success';
        this.confirmAction = () => { this.router.navigate(['/client/list']); };
        this.showConfirmModal = true;
      },
      (error) => {
        this.confirmTitle = 'Erreur';
        this.confirmMessage = error.error ? error.error.error : 'Une erreur est survenue';
        this.confirmIcon = 'fa fa-times';
        this.confirmBtnText = 'Ok';
        this.confirmBtnClass = 'btn btn-danger';
        this.confirmAction = () => {};
        this.showConfirmModal = true;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/client/client-view/client-view.component.ts